import React from 'react';
import PropTypes from 'prop-types';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Row, Col, Input, Select, Radio, InputNumber, Button, Tooltip } from 'antd';
import modal from '~hocs/modal';

@modal({ className: 'long-tail-deposit-modal' })
class DepositModalForm extends React.Component {
  constructor() {
    super();

    this.depositType = null;
    this.state = {
      disableBtn: false,
    };
  }

  componentDidMount() {
    if (this.props.deposit) {
      this.props.form.setFieldsValue({
        name: this.props.deposit.name,
        paymentType: this.props.deposit.paymentType,
        amount: this.props.deposit.amount,
        currency: this.props.deposit.currency,
        description: this.props.deposit.description,
        payThroughStcom: this.props.deposit.payThroughStcom,
      });
    }
  }

  handleConfirm = () => {
    this.props.form.validateFields((err, value) => {
      if (!err && !this.state.disableBtn) {
        this.setState({ disableBtn: true });
        this.props.onSubmit(value, this.props.deposit?.type, () => {
          this.setState({ disableBtn: false });
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { t, paymentOnline } = this.props;

    return (
      <div
        className="long-tail__deposit-modal"
        ref={node => {
          this.depositModal = node;
        }}
      >
        <div className="long-tail__deposit-modal__content">
          <button className="long-tail__deposit-modal__btn--close long-tail__deposit-modal__btn">
            <CloseOutlined
              className="long-tail__deposit-modal__icon-close"
              onClick={() => {
                this.props.onClose(false);
              }}
            />
          </button>
          <h3 className="long-tail__deposit-modal__title">
            {t(
              `landlord.payment.long_tail.${
                this.props.deposit ? 'edit' : 'create'
              }_deposit_information.title`,
            )}
          </h3>

          <Form>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label={t('landlord.payment.long_tail.deposite_name.field')}
                  colon={false}
                >
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        validator: (rule, value, callback) => {
                          if (value && value !== '' && value.length <= 30) {
                            callback();
                          } else if (value && value !== '' && value.length > 30) {
                            callback(
                              this.props.t(
                                'landlord.payment.long_tail.initial_setup.err.name.30_characters',
                              ),
                            );
                          } else {
                            callback(this.props.t('landlord.payment.long_tail.empty.err'));
                          }
                        },
                      },
                    ],
                  })(
                    <Input
                      placeholder={t('landlord.payment.long_tail.deposite_name.field.placeholder')}
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={t('landlord.payment.long_tail.deposite_type.field')}
                  colon={false}
                >
                  <div
                    ref={node => {
                      this.depositType = node;
                    }}
                  >
                    {getFieldDecorator('paymentType', {
                      rules: [
                        {
                          required: true,
                          message: t('landlord.payment.long_tail.empty.err'),
                        },
                      ],
                      initialValue: 'FIXED_AMOUNT',
                    })(
                      <Select getPopupContainer={() => this.depositType}>
                        <Select.Option key="FIXED_AMOUNT" value="FIXED_AMOUNT">
                          {t('landlord.payment.long_tail.deposite_type.field.option.fixed_amount')}
                        </Select.Option>
                        <Select.Option key="PER_BILLING_CYCLE" value="PER_BILLING_CYCLE">
                          {t(
                            'landlord.payment.long_tail.deposite_type.field.option.per_billing_cycle',
                          )}
                        </Select.Option>
                      </Select>,
                    )}
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label={t('landlord.payment.long_tail.amount.field')} colon={false}>
                  {getFieldDecorator('amount', {
                    validateFirst: true,
                    rules: [
                      {
                        required: true,
                        message: t('landlord.payment.long_tail.empty.err'),
                      },
                      {
                        validator: (_, value, callback) => {
                          if (value !== '' && Number(value) === 0) {
                            callback(t('landlord.payment.long_tail.amount.error_zero'));
                          }
                          callback();
                        },
                      },
                      {
                        validator: (_, value, callback) => {
                          if (
                            this.props.form.getFieldValue('paymentType') === 'FIXED_AMOUNT' &&
                            value &&
                            String(value)
                              ?.split('')
                              ?.filter(item => /\d/.test(item)).length > 8
                          ) {
                            return callback(t('landlord.payment.long_tail.amount.error_limit'));
                          }

                          return callback();
                        },
                      },
                    ],
                  })(
                    <InputNumber
                      placeholder={'0'}
                      min={this.props.form.getFieldValue('paymentType') === 'FIXED_AMOUNT' ? 0 : 1}
                      max={
                        this.props.form.getFieldValue('paymentType') === 'FIXED_AMOUNT'
                          ? Infinity
                          : 9999
                      }
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={t('landlord.payment.long_tail.currency.field')} colon={false}>
                  {getFieldDecorator('currency', {
                    rules: [
                      {
                        required: true,
                        message: t('landlord.payment.long_tail.empty.err'),
                      },
                    ],
                    initialValue: this.props.currency, // TODO
                  })(<Input disabled />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label={t('landlord.payment.long_tail.description.field')} colon={false}>
                  {getFieldDecorator('description', {
                    rules: [
                      {
                        validator: (rule, value, callback) => {
                          if (!value || value.length <= 255) {
                            callback();
                          } else {
                            callback(this.props.t('landlord.payment.long_tail.decription.error'));
                          }
                        },
                      },
                    ],
                  })(
                    <Input.TextArea
                      style={{ minHeight: '72px' }}
                      placeholder={t('landlord.payment.long_tail.description.placeholder')}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label={t('landlord.payment.long_tail.pay_to.filed')} colon={false}>
                  {getFieldDecorator('payThroughStcom', {
                    rules: [
                      {
                        required: true,
                        message: t('landlord.payment.long_tail.empty.err'),
                      },
                    ],
                    initialValue: paymentOnline ? true : false,
                  })(
                    <Radio.Group
                      disabled={
                        this.props.deposit || this.props.isPaytoStudentBtnDisabled ? true : false
                      }
                    >
                      <Radio value>{t('landlord.payment.long_tail.button.yes')}</Radio>
                      <Radio value={false}>{t('landlord.payment.long_tail.button.no')}</Radio>
                    </Radio.Group>,
                  )}
                </Form.Item>
                <div className="long-tail__deposit-tooltip-box">
                  <Tooltip
                    placement={'top'}
                    overlayStyle={{ zIndex: '10000000' }}
                    title={t('landlord.payment.long_tail.pay_to.tooltip')}
                  >
                    <QuestionCircleOutlined className="long-tail__initial-setup__label-icon" />
                  </Tooltip>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="long-tail__deposit-modal__footer">
          <Button
            className="long-tail__modal__btn long-tail__modal__btn--cancel"
            onClick={() => {
              this.props.onClose(false);
            }}
          >
            {t('landlord.payment.long_tail.button.cancel')}
          </Button>
          <Button
            type="primary"
            loading={this.state.disableBtn}
            disabled={this.state.disableBtn}
            onClick={this.handleConfirm}
            className="long-tail__modal__btn long-tail__modal__btn--save"
          >
            {t('landlord.payment.long_tail.button.save')}
          </Button>
        </div>
      </div>
    );
  }
}

DepositModalForm.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  deposit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    paymentType: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    description: PropTypes.string,
    payThroughStcom: PropTypes.bool.isRequired,
  }),
  currency: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  isPaytoStudentBtnDisabled: PropTypes.bool,
};
DepositModalForm.defaultProps = {
  t: () => {},
  type: 'create',
  deposit: null,
  currency: '',
  isPaytoStudentBtnDisabled: false,
};

const DepositModal = Form.create({ name: 'long-tail-deposit' })(DepositModalForm);

export default DepositModal;
